import React from 'react'
import CybsIcon from '@cybs-ui/components/lib/icon'
import {putDataInDevCenterDataStore} from '../../../app/store';
import {getCustomHeaders, getCustomHeaderCounter, getPath} from '../../../lhs/reducers/lhs-reducer';
import {getApiHostURL,getCurrentAuthType, getMerchantId, getProcessor} from '../../../lhs/reducers/configuration-reducer';
import getExamplesDataAndStoreInDataStore from './example-actions';
import {getLHSReducerData} from '../../../lhs/reducers/lhs-reducer';
import generateSelectOperationOnExamplePreLoad from '../../dynamic/components/tree/js/js-tree-operations';
import {getJsonSource, getMethodType, getIsJstreeExpansionLimited} from '../../../lhs/reducers/lhs-reducer';
import {addItemsToJsonTree} from '../components/tree/js/js-tree-operations'
import {initiateDeepLinkForRHS} from '../../../commons/deeplinking';
import {getIsWidget, getWidgetExampleKey} from '../../../lhs/reducers/configuration-reducer';

import {getDeepLinkFlag,getPartnerName} from '../../../lhs/reducers/configuration-reducer';
import {showDivBasedOnId, hideDivBasedOnId, clickDivBasedOnClass, isDefaultSite} from '../../../commons/ui-commons';
import axios from 'axios';
import '../components/rhs-components/css//live-console.css'
import {getCredCookie} from '../../../commons/cookie';
import $ from 'jquery';
import { getExampleKey } from '../reducers/examples-reducer';
import {getJsTree, getRequiredFieldsFlag, getSchema} from '../reducers/rhs-schema-reducer';
import {updateLinksInDescription} from "../../../libs/common-library";
// function to check if the given verb of the api is a http verb
function isHttpVerb(pathDetails) {
    var verb = pathDetails.trim().toLowerCase();
    if (verb === 'post' || verb === 'get' || verb === 'put' || verb === 'delete' || verb === 'patch') {
        return true;
    }
    return false;
}

// update HostUrl In dev Center
function updateHostUrlInDevCenter(inputJson)
{   
    if (inputJson.basePath === undefined) {
        inputJson.basePath = "/rest";
    }

    if (inputJson.basePath == "/")
        inputJson.basePath = "";

    var host = getApiHostURL();
    
    if(host == undefined)
    {
        host = inputJson.host + inputJson.basePath;
    }
    if (inputJson.schemes != undefined) {
        host = inputJson.schemes[0] + "://" + host ;
    } else {
        host = "https://" + host;
    }
    putDataInDevCenterDataStore({type:'UPDATE_HOST',host:host});
    putDataInDevCenterDataStore({type:'UPDATE_SPEC_DATA',specData:inputJson});
    putDataInDevCenterDataStore({type:'UPDATE_API_URL',apiUrl:host+getPath()});
}

function sortCheckedList(checkedNodes, jsTreeContents){
    var sortedCheckedList = new Array();
    var treeFieldList = [];
    let fieldMap = new Map();
    for(var index in checkedNodes){
        fieldMap.set(checkedNodes[index], true)
    }
    treeFieldList = getFieldList(jsTreeContents, treeFieldList);
    for(var fieldListIndex in treeFieldList){
        if(fieldMap.get(treeFieldList[fieldListIndex]) !== undefined){
            sortedCheckedList.push(treeFieldList[fieldListIndex]);
        }
    }
    return sortedCheckedList;
}

async function updateSpecBasedExampleData(exampleValue,requiredFields,newJsTreeFlag){
    var treeFieldList = [];
    var jsTreeContents;
    if(newJsTreeFlag){
        jsTreeContents = await iterateJsonAndGetPrimitiveJsonAsync('request', getSchema(), undefined, requiredFields);
        putDataInDevCenterDataStore({type:'UPDATE_JS_TREE',jsTree:jsTreeContents});
    }
    else{
        jsTreeContents = getJsTree();
    }
    treeFieldList = getFieldList(jsTreeContents, treeFieldList);
    var jsTreeChecked = generateSelectOperationOnExamplePreLoad(exampleValue,treeFieldList);
    putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_CHECK_BOX',jsTreeChecked:jsTreeChecked});
    var newExampleValue = {};
    for(var items in jsTreeChecked){
        newExampleValue = addItemsToJsonTree(jsTreeChecked[items],exampleValue,newExampleValue,jsTreeContents);
    }
    if(newExampleValue !== exampleValue){
        // Optimize: stringify once and reuse
        const stringifiedValue = JSON.stringify(newExampleValue, null, 2);

        putDataInDevCenterDataStore({type:'UPDATE_EXAMPLE_VALUE',exampleValue:stringifiedValue});
        putDataInDevCenterDataStore({type:'UPDATE_REQUEST_VALUE',requestValue:stringifiedValue});
    }
}

// Function to construct Category Tag array Contents
function constructCategoryTagArrayContents(spec)
{
    var categoryTagDescriptionObject = [];
    // execute the function only when the x-dev-center-undefined
    if(spec["x-devcenter-metaData"] != undefined)
    {
        putDataInDevCenterDataStore({type:'UPDATE_X-DEVCENTER-METADATA',xDevCenterMetaData:spec["x-devcenter-metaData"]});
    }
    if (spec["x-devcenter-metaData"] != undefined && spec["x-devcenter-metaData"]["categoryTagArray"] != undefined) {
        var itemArray = spec["x-devcenter-metaData"]["categoryTagArray"];
        for (var index in itemArray) {
            if (itemArray[index].name != undefined) {
                if (itemArray[index].description != undefined) {
                    categoryTagDescriptionObject[itemArray[index].name] = itemArray[index].description;
                    // renderMarkdownObj(itemArray[index].name, itemArray[index].description);
                }
            }
        }
        putDataInDevCenterDataStore({type:'UPDATE_CATEGORY_TAG_CONTENTS',categoryTagArrayContents:categoryTagDescriptionObject});
    }
    populateStaticLinkContents(spec);
}

// function to populate static link contents into spec 
function populateStaticLinkContents(spec)
{
    var methodType = getMethodType();
    var partnerName= getPartnerName();
    var path = getPath();
    if(spec["paths"]!= undefined){
    if(spec["paths"][path]!= undefined){
    if(spec["paths"][path][methodType]!= undefined)
    {
        if(spec["paths"][path][methodType]["x-devcenter-metaData"] != undefined)
        {
            var headersMap = {}
            headersMap['host'] = getApiHostURL();
            if(methodType == 'post' || methodType == 'patch' || methodType == 'put'){
                headersMap['Content-Type'] = "application/json";
            }
            if(getCurrentAuthType() == "HTTP Signature")
            {
                headersMap['v-c-merchant-id'] = getCredCookie("merchantId");
                headersMap['v-c-date'] = "Send Request to Generate Date Value";
                if(methodType == 'post' || methodType == 'patch' || methodType == 'put'){
                    headersMap['digest'] = "Send Request to Generate Digest";
                }
                headersMap['signature'] = "Send Request to Generate Signature"
            }
            else if(getCurrentAuthType() == "Json Web Token")
            {
                headersMap['v-c-merchant-id'] = getCredCookie("jwtMerchantId");
                headersMap['authorization'] = "Send Request to Generate Bearer Token"
            }
            
            putDataInDevCenterDataStore({type:'UPDATE_REQUEST_HEADERS',requestHeaders:headersMap});
            // populate static link contents for developer guide
            if(spec["paths"][path][methodType]["x-devcenter-metaData"]["developerGuides"] != undefined)
            {
                putDataInDevCenterDataStore({type:'UPDATE_DEVELOPER_GUIDE_LINK',developerGuideLink:spec["paths"][path][methodType]["x-devcenter-metaData"]["developerGuides"].replace("https://developer.cybersource.com", '').replace("/docs/cybs/", `/docs/${partnerName}/`)});
            }
            else{
                putDataInDevCenterDataStore({type:'UPDATE_DEVELOPER_GUIDE_LINK',developerGuideLink:undefined});
            }
            // populate static link contents for overview link
            if(spec["paths"][path][methodType]["x-devcenter-metaData"]["seeOverViewLink"] != undefined)
            {
                putDataInDevCenterDataStore({type:'UPDATE_SEE_OVERVIEWLINK',seeOverViewLink:spec["paths"][path][methodType]["x-devcenter-metaData"]["seeOverViewLink"].replace("https://developer.cybersource.com", '')});
            }
            // populate static link contents for responsecodes
            if(spec["paths"][path][methodType]["x-devcenter-metaData"]["responseCodes"] != undefined)
            {
                putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_CODES',responseCodes:spec["paths"][path][methodType]["x-devcenter-metaData"]["responseCodes"].replace("https://developer.cybersource.com", '')});
            }
            else{
                putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_CODES',responseCodes:undefined});
            }
            // populate static link contents for testing triggers
            if(spec["paths"][path][methodType]["x-devcenter-metaData"]["testingTriggers"] != undefined)
            {
                putDataInDevCenterDataStore({type:'UPDATE_TESTING_TRIGGER',testingTriggers:spec["paths"][path][methodType]["x-devcenter-metaData"]["testingTriggers"].replace("https://developer.cybersource.com", '')})
            }
            else{
                putDataInDevCenterDataStore({type:'UPDATE_TESTING_TRIGGER',testingTriggers:undefined});
            }
        }   
            updateQueryParams(spec,path,methodType)
        }   
    }
  }
}

function updateQueryParams(spec,path,methodType)
{
    if(spec["paths"][path][methodType]["x-queryParameterDefaults"] != undefined){
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMS_DEFAULT_VALUES',queryParamsDefaultValues:spec["paths"][path][methodType]["x-queryParameterDefaults"]});
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMS_CONTROL',queryParamsControl:'liveConsole'});
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:{...spec["paths"][path][methodType]["x-queryParameterDefaults"]}});
    }
}
// function to populate parameters - simplified without object pooling
function populateParameters(spec, parameterType) {
    const parameterList = [];
    
    for (let i = 0; i < spec.length; i++) {
        const item = spec[i];
        
        if (item.in === parameterType && !item.hasOwnProperty("x-hide-field")) {
            const parameters = {
                in: item.in
            };
            
            // Only assign properties that exist to avoid undefined values
            if (item.name !== undefined) parameters.name = item.name;
            if (item.description !== undefined) parameters.description = item.description;
            if (item.required !== undefined) parameters.required = item.required;
            if (item.type !== undefined) parameters.type = item.type;
            if (item.additionalInformation !== undefined) parameters.additionalInformation = item.additionalInformation;
            
            parameterList.push(parameters);
        }
    }
    
    return parameterList;
}

// Enhanced batching with selective processing and memory optimization
function populatePathQueryHeaderParametersForSchema(spec) {
    var pathParameterList = populateParameters(spec,"path");
    // path Parameter list 
    if(pathParameterList !=undefined && pathParameterList.length>0)
    {
        putDataInDevCenterDataStore({type:'UPDATE_PATH_PARAMETERS',pathParameters:pathParameterList});
    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_PATH_PARAMETERS',pathParameters:[]});
    }

    var headerParameterList = populateParameters(spec,"header");
    // header Parameter list 
    if(headerParameterList != undefined && headerParameterList.length>0)
    {
        putDataInDevCenterDataStore({type:'UPDATE_HEADER_PARAMETERS',headerParameters:headerParameterList});
    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_HEADER_PARAMETERS',headerParameters:[]});
    }
    
    var queryParameterList = populateParameters(spec,"query");
    // query Parameter list 
    if(queryParameterList!=undefined && queryParameterList.length>0)
    {
        putDataInDevCenterDataStore({type:'UPDATE_HAS_QUERY_PARAMS',hasQueryParams:true});
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS',queryParameters:queryParameterList});
    }
    else{
        putDataInDevCenterDataStore({type:'UPDATE_HAS_QUERY_PARAMS',hasQueryParams:false});
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS',queryParameters:[]});
        putDataInDevCenterDataStore({type:'UPDATE_QUERY_PARAMETERS_CURRENT_VALUES',queryParamsCurrentValues:{}});
    }
}

// Memoization cache for schema dereferencing
const dereferenceCache = new Map();

// function to choose dereference for cybs with memoization
function dereferenceForCybs(schema, schemaType) {
    // Return early for undefined schemas
    if(schema == undefined){
        return null;
    }
    
    // Create cache key based on schema content and type
    const cacheKey = JSON.stringify(schema) + '|' + schemaType;
    
    // Check cache first
    if(dereferenceCache.has(cacheKey)) {
        return dereferenceCache.get(cacheKey);
    }
    
    var updatedSchema = schema;
    
    if(schema['additionalProperties'] != undefined && schemaType == 'response') {
        updatedSchema.dereferencedParameter = {};
        updatedSchema.dereferencedParameter.properties = {};    
        if(schema['additionalProperties']['type'] != undefined && schema['additionalProperties']['type'] == 'object') { 
            updatedSchema.dereferencedParameter['properties']['propertyName*'] = dereferenceForCybs(schema['additionalProperties'], schemaType);
        } else {
            updatedSchema.dereferencedParameter['properties']['propertyName*'] = schema['additionalProperties'];
        }
    } else if ((schema['type'] != undefined && schema['type'] == 'object') || 
    (schema['type'] == undefined && schema['properties'] != undefined)) {
      updatedSchema.dereferencedParameter = {};
      var properties = schema.properties;
      updatedSchema.dereferencedParameter.properties = {};
      for (var pindex in properties) {
        updatedSchema.dereferencedParameter['properties'][pindex] = dereferenceForCybs(properties[pindex], schemaType);
      }      
    } else if(schema['type'] != undefined && schema['type'] == 'array'){
      schema.items = dereferenceForCybs(schema.items, schemaType);
    } else if(schema['allOf'] != undefined && schema['allOf'] != null) { 
        var allObjects = schema['allOf'];
        updatedSchema.dereferencedParameter = {};
        updatedSchema.dereferencedParameter.properties = {};
        for (var index in allObjects) {
            var childSchema = allObjects[index];
            var properties = childSchema.properties;
            for (var pindex in properties) {
                updatedSchema.dereferencedParameter['properties'][pindex] = dereferenceForCybs(properties[pindex], schemaType);
            }
        }
    } else {
      // Cache and return the original schema for leaf nodes
      dereferenceCache.set(cacheKey, schema);
      return schema;
    }
    
    // Cache the result before returning
    dereferenceCache.set(cacheKey, updatedSchema);
    return updatedSchema;
}

// Function to clear the dereference cache (call when loading new schemas)
function clearDereferenceCache() {
    dereferenceCache.clear();
}


async function parseJsonDataAndExtractBodyAndQueryParams(spec,processorSwitchFlag)
{
    putDataInDevCenterDataStore({type:'UPDATE_REQUIRED_FIELDS_FLAG',requiredFieldsFlag:false});
    for (var api in spec.paths) {
        for (var operation in spec.paths[api]) {
          if (isHttpVerb(operation) && getMethodType() == operation) {
            if (spec.paths[api][operation]['x-example'] != undefined && spec.paths[api][operation]['x-example'] != null) {
             if(!processorSwitchFlag){
                spec.paths[api][operation].selectedExampleKey = Object.keys(spec.paths[api][operation]['x-example'])[0];
             }
             else{
                spec.paths[api][operation].selectedExampleKey = getExampleKey();
             }
             if(getIsWidget()){
                spec.paths[api][operation].selectedExampleKey = getWidgetExampleKey();
             }
             var lhsData = getLHSReducerData();
             getExamplesDataAndStoreInDataStore(spec.paths[api][operation]['x-example'], spec.paths[api][operation].selectedExampleKey, lhsData.firstLevelKey, lhsData.secondLevelKey,lhsData.summary,processorSwitchFlag);
            }
            else{
              var lhsData = getLHSReducerData();
              getExamplesDataAndStoreInDataStore(undefined, undefined, lhsData.firstLevelKey, lhsData.secondLevelKey,lhsData.summary,processorSwitchFlag);
            }
  
            var operationDetails = spec.paths[api][operation];
            var parameters = operationDetails.parameters;
            var exampleValue = "";
            var requiredFields = [];
            populatePathQueryHeaderParametersForSchema(parameters);
            putDataInDevCenterDataStore({type:'UPDATE_JS_TREE',jsTree:undefined});
            //putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_EXPANDED', jsTreeExpanded: undefined}); 
            var commonDescription = spec.paths[api][operation]['description'];
            if(commonDescription != undefined && getPartnerName() != 'cybs' && (commonDescription.includes('/docs/cybs/')
                || commonDescription.includes('https://developer.cybersource.com'))){
              commonDescription = updateLinksInDescription(commonDescription, getPartnerName());
              putDataInDevCenterDataStore({type:'UPDATE_DESCRIPTION',description:commonDescription});
            }
            for (var pindex in parameters) {
              var param = parameters[pindex];
              if (param.in == "body") {
                if (param.schema['type'] == 'object') {
                    putDataInDevCenterDataStore({type:'UPDATE_SCHEMA',schema:dereferenceForCybs(param.schema, '')});
                    if('x-example' in spec.paths[api][operation] && 'selectedExampleKey' in spec.paths[api][operation]){
                        exampleValue = (spec.paths[api][operation]['x-example'][spec.paths[api][operation].selectedExampleKey]["value"]);
                        if('requiredFields' in spec.paths[api][operation]['x-example'][spec.paths[api][operation].selectedExampleKey]){
                            requiredFields = spec.paths[api][operation]['x-example'][spec.paths[api][operation].selectedExampleKey]['requiredFields'];
                        }
                    }
                    else if('example' in param.schema){
                        exampleValue = param.schema['example'];
                    }
                    var jsTreeContents = await iterateJsonAndGetPrimitiveJsonAsync('request', param.schema, undefined, requiredFields);
                    jsTreeContents = markParentAsRequired(jsTreeContents, jsTreeContents);
                    var expandJstreeTillLevel = Infinity;
                    if(getIsJstreeExpansionLimited()){
                        expandJstreeTillLevel = 7;
                    }
                    putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_EXPANDED', jsTreeExpanded: expandNodesToLevel(jsTreeContents, expandJstreeTillLevel)})
                    putDataInDevCenterDataStore({type:'UPDATE_JS_TREE_EXPANDED_FLAG', jsTreeExpandedFlag: true});
                    putDataInDevCenterDataStore({type:'UPDATE_JS_TREE',jsTree:jsTreeContents});
                    updateSpecBasedExampleData(exampleValue,requiredFields,false);
                }
              }
              if(param.in == "query" && !(param.hasOwnProperty("x-hide-field"))){
                operationDetails.hasQueryParams = true;
                if(param.required){
                  operationDetails.hasMandatoryQueryParams=true;
                  putDataInDevCenterDataStore({type:'UPDATE_HAS_MANDATORY_QUERY_PARAMS',hasMandatoryQueryParams:true});
                }
              }
              if(param.in == "header" && !(param.hasOwnProperty("x-hide-field"))){
                  var customHeadersContent = getCustomHeaders();
                  if(customHeadersContent == undefined)
                  {
                    customHeadersContent = {};
                  }
                  if("default" in param)
                  {
                    customHeadersContent[param.name] = param.default;
                  }
                  else
                  {
                    customHeadersContent[param.name] = ""   ;
                  }
                 putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS',customHeaders:customHeadersContent});
                 var customHeaderCounter = getCustomHeaderCounter();
                 if(customHeaderCounter !== undefined){
                    putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS_COUNTER',customHeaderCounter:++customHeaderCounter});
                 }
                 else{
                    putDataInDevCenterDataStore({type:'UPDATE_CUSTOM_HEADERS_COUNTER',customHeaderCounter:0});
                 }
              }
            }

            // creating a jsTree like data structure for response tree
            var response = operationDetails.responses;
            var responseList = [];
            var responseItem = {};
            for(var responseCode in response){
                responseItem['label'] = responseCode;
                responseItem['value'] = responseCode;
                responseItem['description'] = response[responseCode].description;
                
                if('schema' in response[responseCode]){                  
                    response[responseCode].schema = dereferenceForCybs(response[responseCode].schema, 'response');
                    response[responseCode].schema = await iterateJsonAndGetPrimitiveJsonAsync('response', response[responseCode].schema, responseCode, undefined);
                    responseItem['children'] = response[responseCode].schema;
                }
                
                responseList.push(responseItem);
                responseItem = {};
            }
            putDataInDevCenterDataStore({type:'UPDATE_RESPONSE_TREE',responseTree:responseList});
          }
        }
      }
      
}

function getFieldList(jsTreeArray, treeFieldList = []) {
    for (const jsTreeElement of jsTreeArray) {
        if (jsTreeElement.children?.length > 0) { // Optional chaining for safety
            getFieldList(jsTreeElement.children, treeFieldList);
        } else {
            treeFieldList.push(jsTreeElement.value);
        }
    }
    return treeFieldList;
}


function expandNodesToLevel(nodes, targetLevel, currentLevel = 0) {
    if (currentLevel > targetLevel) {
      return [];
    }
  
    const expanded = [];
    const stack = [];
    
    // Initialize stack with root nodes
    for (let i = 0; i < nodes.length; i++) {
        stack.push({ node: nodes[i], level: currentLevel });
    }
    
    // Iterative traversal instead of recursive
    while (stack.length > 0) {
        const { node, level } = stack.pop();
        
        if (level > targetLevel) {
            continue;
        }
        
        expanded.push(node.value);
        
        // Add children to stack if within target level
        if (node.children && level < targetLevel) {
            for (let i = node.children.length - 1; i >= 0; i--) {
                stack.push({ node: node.children[i], level: level + 1 });
            }
        }
    }
    
    return expanded;
}

async function iterateJsonAndGetPrimitiveJsonAsync(treeType, schema, parent, requiredFields, onProgress) {
    const TreeElementArray = [];
    const properties = schema.dereferencedParameter?.properties || schema.items?.properties || {};
    const propertyKeys = Object.keys(properties);
    const parentSchema = schema.dereferencedParameter || schema.items || schema;
    
    // Process in larger chunks for better performance
    const chunkSize = 50;
    
    for (let i = 0; i < propertyKeys.length; i += chunkSize) {
        const chunk = propertyKeys.slice(i, i + chunkSize);
        
        // Process chunk
        for (const property of chunk) {
            const TreeElement = await processTreeProperty(treeType, parentSchema, property, parent, requiredFields, properties[property]);
            if (TreeElement) {
                TreeElementArray.push(TreeElement);
            }
        }
        
        // Only yield control for very large datasets to prevent UI blocking
        if (propertyKeys.length > 100 && i % 100 === 0) {
            await new Promise(resolve => setTimeout(resolve, 0));
        }
        
        // Report progress
        if (onProgress) {
            onProgress(i + chunk.length, propertyKeys.length);
        }
    }
    
    return TreeElementArray;
}

async function processTreeProperty(treeType, parentSchema, property, parent, requiredFields, propertySchema) {
    const value = parent ? `${parent}-${property.replace(/_/g, '*')}` : property.replace(/_/g, '*');
    
    if (treeType === 'request' && propertySchema.readOnly) {
        return null;
    }
    
    // Process children recursively (but still async)
    const children = await iterateJsonAndGetPrimitiveJsonAsync(treeType, propertySchema, value, requiredFields);
    const TreeElement = {
        showCheckbox: true,
        value: value,
        label: propertySchema.description ? 
            (<>{property + " "}<CybsIcon name='info' resolution='tiny' dataTest='info'/></>) : 
            property
    };
    
    if (children.length > 0) {
        TreeElement.children = children;
        TreeElement.type = propertySchema.type;
    } else {
        TreeElement.type = "Object";
    }
    
    if (requiredFields != undefined) {
        if (requiredFields.includes(TreeElement['value'].replace(/-/g, '.').replace(/\*/g, '_'))) {
            TreeElement["required"] = "true";
            TreeElement["className"] = "required";
        }
    }
    if (parentSchema["required"] !== undefined) {
        if (parentSchema["required"].includes(property)) {
            TreeElement["className"] = "required";
            if (!getRequiredFieldsFlag()) {
                putDataInDevCenterDataStore({ type: 'UPDATE_REQUIRED_FIELDS_FLAG', requiredFieldsFlag: true });
            }
        }
    }

    if (property != 'propertyName*') {
        TreeElement["description"] = property;
    }

    for (var childProps in propertySchema) {
        if (childProps == "description") {
            TreeElement["description"] = propertySchema[childProps];
        }
        if (childProps == "additionalInformation") {
            TreeElement["additionalInformation"] = propertySchema[childProps];
        }
        if (childProps == "type") {
            TreeElement["type"] = propertySchema[childProps];
        }
        if (childProps == "maxLength") {
            TreeElement["maxLength"] = propertySchema[childProps];
        }
        if (childProps == "minLength") {
            TreeElement["minLength"] = propertySchema[childProps];
        }
        if (childProps == "pattern") {
            TreeElement["pattern"] = propertySchema[childProps];
        }
        if (childProps == "required") {
            TreeElement["required"] = propertySchema[childProps];
            if (TreeElement["className"] !== "required") {
                TreeElement["className"] = "custom-required";
                if (!getRequiredFieldsFlag()) {
                    putDataInDevCenterDataStore({
                        type: 'UPDATE_REQUIRED_FIELDS_FLAG',
                        requiredFieldsFlag: true
                    });
                }
            }
            for (var requiredChildIndex = 0; requiredChildIndex < TreeElement["required"].length; requiredChildIndex++) {
                var childObj = TreeElement["required"][requiredChildIndex];
                if (TreeElement.children && TreeElement.children.length > 0) {
                    for (var childIndex = 0; childIndex < TreeElement.children.length; childIndex++) {
                        if (TreeElement.children[childIndex].value == TreeElement.value + '-' + childObj) {
                            TreeElement.children[childIndex]["className"] = "required";
                        }
                    }
                }
            }
        }
    }
    if (property == 'items') {
        if (propertySchema["required"] != undefined) {
            for (var requiredChildIndex = 0; requiredChildIndex < propertySchema["required"].length; requiredChildIndex++) {
                if (TreeElement.value.indexOf("-" + propertySchema["required"][requiredChildIndex].replace(/_/g, '*')) > -1) {
                    TreeElement["className"] = "required";
                }
            }
        }
    }
    
    return TreeElement;
}

function markParentAsRequired(jsonTree, treeElementArray) {
    // Create a map for faster lookups
    const nodeMap = new Map();
    const requiredPaths = [];
    
    // Build node map and collect required paths in one pass
    const buildMapAndCollectRequired = (elements, map) => {
        const stack = [...elements];
        
        while (stack.length > 0) {
            const element = stack.pop();
            map.set(element.value, element);
            
            if (element.className === "required" && element.value.indexOf("-") > -1) {
                requiredPaths.push(element.value);
            }
            
            if (element.children && element.children.length > 0) {
                stack.push(...element.children);
            }
        }
    };
    
    buildMapAndCollectRequired(treeElementArray, nodeMap);
    
    // Mark parents for all required paths
    for (const fieldVal of requiredPaths) {
        markAllParentsAsRequiredOptimized(fieldVal, nodeMap);
    }
    
    return jsonTree;
}

function markAllParentsAsRequiredOptimized(fieldVal, nodeMap) {
    const parts = fieldVal.split("-");
    
    // Mark all parent paths efficiently
    for (let i = 1; i < parts.length; i++) {
        const parentPath = parts.slice(0, i).join("-");
        const parentElement = nodeMap.get(parentPath);
        
        if (parentElement && parentElement.className !== "required") {
            parentElement.className = "custom-required";
        }
    }
}

 //Derefernce model definitions and to load first action in each apifamily
 async function LoadRefData(inputJson,processorSwitchFlag) {
    updateHostUrlInDevCenter(inputJson);
    if(!processorSwitchFlag){
        constructCategoryTagArrayContents(inputJson);
    }
    await parseJsonDataAndExtractBodyAndQueryParams(inputJson,processorSwitchFlag);
    if(!isDefaultSite())
    {
        $('.api-reference .vds-state--selected').addClass('border_color_theme_primary_bottom');
    }
    else{
        $('.api-reference .vds-state--selected').css('border-bottom','3px solid #2defe0 !important');
    }
   
}

// Background cleanup with batched operations for better performance
async function cleanupApiData() {
    // Clear the dereference cache to prevent memory leaks
    clearDereferenceCache();
    
    // Batch cleanup operations to reduce store update overhead
    const cleanupPayload = {
        specData: null,
        jsTree: null,
        responseTree: null,
        requestHeaders: {},
        customHeaders: {},
        pathParameters: [],
        headerParameters: [],
        queryParameters: [],
        queryParamsCurrentValues: {},
        exampleValue: "",
        requestValue: "",
        schema: null,
        downloadProgress: 0,

        // Add any other API-specific state that needs cleanup
        xDevCenterMetaData: null,
        categoryTagArrayContents: {},
        developerGuideLink: null,
        seeOverViewLink: null,
        responseCodes: null,
        testingTriggers: null,
        
        // Clear flags
        hasQueryParams: false,
        hasMandatoryQueryParams: false,
        requiredFieldsFlag: false,
        jsTreeExpandedFlag: false,
        
        // Clear tree states
        jsTreeExpanded: [],
        jsTreeChecked: [],

        // Clear description-related data
        description: null,
        
        // Clear node interaction states
        nodeClickCheck: false,
        clickedNode: null,
        
        // Clear description expansion states
        descriptionExpansionAlertFlag: false,
        
        // Clear any cached markdown/HTML content
        sanitizedDescriptions: {},
        
        // Clear partner-specific data
        partnerFullName: null,
        
        // Clear any URL hash related data
        currentUrlHash: null,
        
        // Clear any info icon states
        infoIconStates: {},
        
        // If you have any description component instance data
        descriptionComponentInstances: [],
        
        // Clear any aria-expanded states
        ariaExpandedStates: {},
        
        // Clear any border states for hierarchy elements
        hierarchyBorderStates: {},
        
        // Clear any cached tree level keys
        firstLevelKey: null,
        secondLevelKey: null,
        thirdLevelKey: null
    };
    
    // Single batched store update for all cleanup operations
    putDataInDevCenterDataStore({
        type: 'CLEANUP_API_DATA',
        payload: cleanupPayload
    });
}

// function to load json data and generate json contents 
function LoadJsonData(processorSwitchFlag)
{
    // Cleanup before loading new data
    cleanupApiData();
    if(getJsonSource())
    {
        hideDivBasedOnId("bodyTab");
        hideDivBasedOnId("live-console");
        hideDivBasedOnId("requestBuilderJsTreeTab");    
        showDivBasedOnId("JstreeLoaderIndicator");
        showDivBasedOnId("BodyTabLoaderIndicator");
        hideDivBasedOnId("sample-request-data");
        const homePage = require('../../../dist/json/config.json');
        // var currentProcessor = ('singleSourceFlag' in homePage && homePage['singleSourceFlag']=="true")?(getProcessor()+'/'):'';
        var pathPrefix = (homePage.homepage == "" ? '/' : homePage.homepage) + 'specs/' + getJsonSource();
        axios({ url : pathPrefix, onDownloadProgress(progress) {
            var downloadedData = Math.round((progress.loaded/progress.total)*100);
            putDataInDevCenterDataStore({type:'UPDATE_DOWNLOAD_PROGRESS', downloadProgress:downloadedData});
        }}).
        then((response) => {
            LoadRefData(response.data, processorSwitchFlag);
          }, (error) => {
          })
        .then(() =>  {
            setTimeout(function(){
                if(document.querySelector('#sampleRequestDropDownDiv')) {
                    var hashValue = encodeURI(window.location.hash);
                    var decodedHashValue = decodeURI(hashValue)
                    if(getDeepLinkFlag()){
                        var urlIdArray = decodedHashValue.replace('#','').split('_');
                        initiateDeepLinkForRHS(urlIdArray);
                        clickDivBasedOnClass(" CodeMirror-line ");
                        putDataInDevCenterDataStore({type:'UPDATE_DEEPLINK_FLAG', deepLinkFlag: false});
                    }
                }
            }, 1);
        })
        var specDownloadLink = (homePage.homepage == "" ? '/' : homePage.homepage) + 'specs/' + getPartnerName().replace("vas", "voap") + "_merged.json";  
        putDataInDevCenterDataStore({type:'UPDATE_SPEC_DOWNLOAD_LINK', specDownloadLink:specDownloadLink});
    }
}

function getSwaggerJsonData(path)
{
    cleanupApiData();
    if(path)
    {   
            hideDivBasedOnId("bodyTab");
            hideDivBasedOnId("live-console");
            hideDivBasedOnId("requestBuilderJsTreeTab");    
            showDivBasedOnId("JstreeLoaderIndicator");
            showDivBasedOnId("BodyTabLoaderIndicator");
            // fetch('../../../../../../specs/package.json').then(response => response.json()).then(data => console.log(data));
            const homePage = require('../../../dist/json/config.json');
            var pathPrefix = '../../../../../../' + homePage.homepage +'specs/';
            axios({ url : pathPrefix + getJsonSource(), onDownloadProgress(progress) {
                var downloadedData = Math.round((progress.loaded/progress.total)*100);
                putDataInDevCenterDataStore({type:'UPDATE_DOWNLOAD_PROGRESS', downloadProgress:downloadedData});
            }})
            .then((response) => {
                LoadRefData(response.data);
                return response.data;
              }, (error) => {
              })
    }
}
export default LoadJsonData;

export {LoadJsonData,updateQueryParams,getSwaggerJsonData, updateSpecBasedExampleData, sortCheckedList, getFieldList};
